import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Pill from 'srcReact/components/common2/Pill'
import WidgetContainer from '../WidgetContainer'
import styles from './styles.module.scss'

function InterestSuggestion({ suggestions, handleShowMore }) {
  const { t } = useTranslation()
  const [showWidget, setShowWidget] = useState(true)

  const onSuccess = () => {
    setShowWidget(false)
  }
  return showWidget ? (
    <WidgetContainer
      title={t('widgets.interest.title')}
      subTitle={t('widgets.interest.subTitle')}
      imageName='user'
      showMoreLabel={t('global.showMore')}
      handleShowMore={handleShowMore}>
      <div className={styles.interestContainer}>
        {suggestions.map((interest) => (
          <Pill dataId={interest.id} text={interest.name} onAddPillSuccess={onSuccess} askForAddToProfile={true} />
        ))}
      </div>
    </WidgetContainer>
  ) : null
}

export default InterestSuggestion
